'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, person_id) {
  return function (dispatch, getState) {
    var eventsResults = (0, _paths.getResultsByPerson)(getState(), feis_id, person_id);

    // prefer the cached version
    if (eventsResults && eventsResults.size > 0) return;

    return dispatch(_defineProperty({
      person_id: person_id,
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/scores/by-person/' + person_id
      },
      types: ['GET_RESULTS_BY_PERSON_START', 'GET_RESULTS_BY_PERSON', 'GET_RESULTS_BY_PERSON_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/getEventsResultsForParticipant.js
// module id = 639
// module chunks = 0